/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
const tabs = document.querySelectorAll('.tabs-wrapper > div');
const tabbedNavigation = document.querySelector('.tabbed-navigation');
const tabsWrapper = document.querySelector('.tabs-wrapper')

const titles = [...tabs].map((tab) => {
	const title = tab.querySelector('h2').innerHTML;
	return (
		{
			title: title,
			linkedTab: tab
		}
	)
});

titles.forEach((title, i) => {
	const div = document.createElement('button');
	div.className = `filter-item ${i === 0 ? "active" : ""}`;
	div.innerHTML = title.title;

	div.addEventListener('click', () => {

		tabbedNavigation.querySelectorAll('.filter-item').forEach((filterItem) => {
			filterItem.classList.remove('active');
		});

		div.classList.add('active');

		tabs.forEach((tab) => {
			tab.classList.remove('active');
		})
		title.linkedTab.classList.add('active');

		tabsWrapper.scrollTo({
			left: title.linkedTab.offsetLeft - tabsWrapper.offsetLeft,
			behavior: "smooth"
		});
	})

	tabbedNavigation.appendChild(div);

})


//mobile nav 

const navPrev = document.querySelector('.tabbed-navigation-mobile-prev');
const navNext = document.querySelector('.tabbed-navigation-mobile-next');

let autoplay = true;

navPrev.addEventListener('click', () => {
	const activeTab = document.querySelector('.tabs-wrapper .active');
	const prevTab = activeTab.previousElementSibling;

	navNext.classList.remove('disabled');

	if (prevTab) {
		prevTab.classList.add('active');
		activeTab.classList.remove('active');

		tabsWrapper.scrollTo({
			left: prevTab.offsetLeft - tabsWrapper.offsetLeft,
			behavior: "smooth"
		});

		tabsWrapper.style.height = `${prevTab.querySelector('.wp-block-cover').offsetHeight}px`;

	}

	if (!prevTab.previousElementSibling) {
		navPrev.classList.add('disabled');
	}

	autoplay = false;
	clearInterval(autoplayingTabs);
});

navNext.addEventListener('click', () => {
	const activeTab = document.querySelector('.tabs-wrapper .active');
	const nextTab = activeTab.nextElementSibling;

	navPrev.classList.remove('disabled');

	if (nextTab) {
		nextTab.classList.add('active');
		activeTab.classList.remove('active');

		tabsWrapper.scrollTo({
			left: nextTab.offsetLeft - tabsWrapper.offsetLeft,
			behavior: "smooth"
		});

		tabsWrapper.style.height = `${nextTab.querySelector('.wp-block-cover').offsetHeight}px`;
	}

	if (!nextTab.nextElementSibling) {
		navNext.classList.add('disabled');
	}

	autoplay = false;
	clearInterval(autoplayingTabs);

});

//auto nav to next tab mobile
let responsive;
let autoplayingTabs;

const resizeWindow = () => {

	const activeTab = document.querySelector('.tabs-wrapper .active');

	tabsWrapper.scrollTo({
		left: activeTab.offsetLeft - tabsWrapper.offsetLeft,
		behavior: "instant"
	});

	responsive = window.innerWidth < 1101;
	clearInterval(autoplayingTabs);

	if (!responsive) {
		tabsWrapper.style.height = `unset`;
	} else {
		tabsWrapper.style.height = `${activeTab.querySelector('.wp-block-cover').offsetHeight}px`;
	}

	if (autoplay && responsive) {
		autoplayingTabs = setInterval(() => {

			let nextTab;

			navPrev.classList.remove('disabled');
			navNext.classList.remove('disabled');

			const activeTab = document.querySelector('.tabs-wrapper .active');
			nextTab = activeTab.nextElementSibling;

			if (!nextTab) {
				//if at last tab, go to first
				nextTab = document.querySelector('.tabs-wrapper div');
			}

			if (!nextTab.previousElementSibling) {
				navPrev.classList.add('disabled');
			}

			if (!nextTab.nextElementSibling) {
				navNext.classList.add('disabled');
			}

			nextTab.classList.add('active');
			activeTab.classList.remove('active');

			tabsWrapper.scrollTo({
				left: nextTab.offsetLeft - tabsWrapper.offsetLeft,
				behavior: "smooth"
			});

			tabsWrapper.style.height = `${nextTab.querySelector('.wp-block-cover').offsetHeight}px`;


		}, 4000);
	}

}

window.addEventListener('resize', () => {
	resizeWindow();
});

resizeWindow();

/* eslint-enable no-console */
